module.exports = __webpack_public_path__ + "static/media/appstore-qrcode.d33f6825.png";